import $ from 'jquery';

export function panelOpen(){
    const smartOpen = $('.smart-panel__open');
    const smartClose = $('.smart-panel__close');
    const smartContent = $('.smart-panel__content');
    const smartPanel = $('.smart-panel');

    smartOpen.on('click', function(){
        smartContent.addClass('open');
        smartPanel.addClass('open-content');
    })

    smartClose.on('click', function(){
        smartContent.removeClass('open');
        smartPanel.removeClass('open-content');
    })
}


// WEBPACK FOOTER //
// app/scripts/components/panel-open.js